import { render, staticRenderFns } from "./GoalHeader.vue?vue&type=template&id=f8a8917c&"
import script from "./GoalHeader.vue?vue&type=script&lang=js&"
export * from "./GoalHeader.vue?vue&type=script&lang=js&"
import style0 from "./GoalHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports